<app-container>
  <div class="card">
    <div class="p-md pb-lg grid justify-center">
      <app-filters [filters]="filters$ | async" [selected]="selectedFilter" (change)="filterChange($event)">
      </app-filters>

      <app-search (change)="this.search($event)"></app-search>
    </div>

    <div class="flex justify-end">
      <button class="btn btn-primary" routerLink="/events/create" *ngIf="canLaunchEvent">Launch Event</button>
    </div>
    <div class="pb-md">
      <table
        mat-table
        [appApolloBinding]="queryRef"
        [statusFilter]="selectedFilter"
        [search]="_search"
        class="is-fullwidth mb"
        style="width: 100%"
        [paginator]="paginator"
      >
        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef>Open</th>
          <td mat-cell *matCellDef="let event">
            <img alt="" *ngIf="event.image" [src]="event.image" style='max-width: 144px'/>
            <img alt="" *ngIf="!event.image" [src]="(currentUser | async)?.logo" style='max-width: 144px'/>
          </td>
        </ng-container>

        <mat-text-column name="title" headerText="Event Title"></mat-text-column>
        <mat-text-column name="dictationTime" headerText="Length"></mat-text-column>

        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let event">
          <button mat-flat-button *ngIf="event.storagePath">Download Audio</button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let event">
          <button mat-flat-button color="warn" *ngIf="event.storagePath">Delete Audio</button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (click)="cellClick(row, $event)"></tr>
      </table>

      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons #paginator></mat-paginator>
    </div>
    <div class="flex justify-end">
      <button class="btn btn-primary" routerLink="/events/create" *ngIf="canLaunchEvent">Launch Event</button>
    </div>
  </div>
</app-container>
